;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import PropTypes from 'prop-types';

const Portal = ({ selector, children }) => {
    selector ??= '#__portal__';

    const [element, setElement] = useState(null);

    useEffect(() => {
        const element = document.querySelector(selector);
        setElement(element);
    }, [selector]);

    if (!element) {
        return null;
    }

    return ReactDOM.createPortal(children, element);
};

Portal.propTypes = {
    selector: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default Portal;
